/***************************************************************************************
 * PINIA CONFIGURATION
 **************************************************************************************/
import { createPinia, Pinia } from 'pinia';

const pinia: Pinia = createPinia();
export default pinia;
